<ng-container *ngIf="isStatusAsReady()">
  <form [formGroup]="form">
    <div class="form-row">
      <div *ngFor="let formField of formFields" [ngClass]="formField.size">
        <dynamic-form-field [form]="form" (onChangeValue)="retrieveFormValue($event)" [question]="formField"/>
      </div>
    </div>
    <div class="form-row">
      <p class="col-md-12 mandatory">
        <em>* Campi obbligatori</em>
      </p>
    </div>
    <div class="form-row">
      <div class="col-xs-12 col-sm-6"></div>
      <div class="col-xs-6 col-sm-3">
        <button type="button" class="btn btn-outline-secondary btn-block" (click)="resetForm()">Reset</button>
      </div>
      <div class="col-xs-6 col-sm-3">
        <button type="button" class="btn btn-primary btn-block" [disabled]="!canNext()" (click)="doNext()">
          Prosegui
        </button>
      </div>
    </div>
  </form>
</ng-container>

<ng-container *ngIf="isStatusAsWarn() && isSignTypeAsLocal()">
  <div class="form-row">
    <p class="col-md-12 d-flex align-items-center">
      <b>Prima di continuare:</b>
    </p>
    <p class="col-md-12 d-flex align-items-center">
      <em>Assicurarsi di aver avviato l'applicativo di Firma Digitale e di aver inserito il Token USB.</em>
    </p>
  </div>
  <div class="form-row">
    <div class="col-xs-12 col-sm-9"></div>
    <div class="col-xs-6 col-sm-3">
      <button type="button" class="btn btn-primary btn-block" (click)="doNext()">OK</button>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="isStatusAsPassword()">
  <ng-container *ngIf="isSignTypeAsLocal(); else remote">
    <div class="form-row">
      <div class="col-sm-12 p-10">
        <app-sign-document-otp
          [isPin]="true" 
          [label]="'Inserisci il tuo PIN'"
          (otpChange)="doSetPassword($event)"
        />
      </div>
    </div>
  </ng-container>
  <ng-template #remote>
    <div class="form-row">
      <div class="col-sm-12 p-10">
        <app-sign-document-otp
          [isPin]="false" 
          [label]="'Inserisci il codice OTP'"
          (otpChange)="doSetPassword($event, true)"
        />
      </div>
      <div class="col-sm-12 p-10">
        <app-sign-document-otp
          [isPin]="true" 
          [label]="'Inserisci il tuo PIN'"
          [subLabel]="'ATTENZIONE : Se il pin è composto da meno di 8 cifre dovrai aggiungere alcuni 0 all inizio per arrivare a 8 cifre'"
          (otpChange)="doSetPassword($event)"
        />
      </div>
    </div>
  </ng-template>
  <div class="form-row">
    <div class="col-xs-12 col-sm-9"></div>
    <div class="col-xs-6 col-sm-3">
      <button type="button" class="btn btn-primary btn-block" [disabled]="!canNext()" (click)="doNext()">Firma</button>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="isStatusAsError()">
  <div *ngIf="signError" class="row">
    <p class="col-md-12 mandatory d-flex align-items-center justify-content-center">
      <em>{{signError}}</em>
    </p>
  </div>
  <div class="form-row">
    <div class="col-xs-12 col-sm-9"></div>
    <div class="col-xs-6 col-sm-3">
      <button type="button" class="btn btn-primary btn-block" (click)="doSubmit()">OK</button>
    </div>
  </div>
</ng-container>
